import {accessItemTypeEnum} from '../../../serverClientShared/sharedEnums';

export const getRouteDepth = (nestedFolderRoute) => (nestedFolderRoute || '').split('/').filter(Boolean).length;

export const buildChildrenIndex = (folders, procedures) => {
    const byParent = new Map();
    const add = (parentId, child) => {
        const arr = byParent.get(parentId) || [];
        arr.push(child);
        byParent.set(parentId, arr);
    };
    folders.forEach((f) => add(f.ParentFolder || 'root', {kind: accessItemTypeEnum.FOLDER, id: f.FolderIdentifier, name: f.FolderName, raw: f}));
    procedures.forEach((p) => add(p.ParentFolder || 'root', {kind: accessItemTypeEnum.ITEM, id: p.ProcedureIdentifier, name: p.ProcedureName, raw: p}));
    return byParent;
};

export const collectAllProcedureIds = (childrenIndex, folderId) => {
    const ids = [];
    for (const child of childrenIndex.get(folderId) || []) {
        if (child.kind === accessItemTypeEnum.ITEM) ids.push(child.id);
        else ids.push(...collectAllProcedureIds(childrenIndex, child.id));
    }
    return ids;
};

export const matchesSearch = (childrenIndex, folderId, query) => {
    if (!query) return true;
    for (const child of childrenIndex.get(folderId) || []) {
        if (child.name?.toLowerCase().includes(query)) return true;
        if (child.kind === 'folder' && matchesSearch(childrenIndex, child.id, query)) return true;
    }
    return false;
};

export const computeFolderState = (childrenIndex, folderId, selected) => {
    const all = collectAllProcedureIds(childrenIndex, folderId);
    if (!all.length) return 'empty';
    const checkedCount = all.filter((id) => selected.has(id)).length;
    if (checkedCount === 0) return 'unchecked';
    if (checkedCount === all.length) return 'checked';
    return 'indeterminate';
};
